import React from 'react';

function Contact() {
    return (
        <div>
            <div className="container-narrow mb-1 pt-4 px-4">
                <div className=' d-flex justify-content-between w-100 text-center'>
                    <div className="contact-info ">
                        <h2 className='mb-1'>Contact Information</h2>
                        <div className='m-4'>
                            <p>Email:  <strong>s.amthiangtham@gmail.com</strong></p>
                            <p>Phone:  <strong>(+66) 865448466</strong></p>
                            <p>Address: <strong>near Si Thepha MRT Yellow line</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
